import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

import { postCustomerApplication } from '../../actions/user'

import withStyles from "material-ui/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/icons
import InfoOutline from "@material-ui/icons/InfoOutline";

// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Wizard from "components/Wizard/Wizard.jsx";

import Step1 from "./ApplicationWizardSteps/Step1.jsx";
import Step2 from "./ApplicationWizardSteps/Step2.jsx";
import Step3 from "./ApplicationWizardSteps/Step3.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
const applicationStyle = {
  ...sweetAlertStyle,
}

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      add:{},
      wizardId: Date.now(),
      nextStep: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  handleSubmit(){
    this.props.dispatchPostApplication(this.props.auth.user, this.state.add)
    .then( res => {
      this.setState({nextStep:true});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block" }}
            title="Good job!"
            onConfirm={() => this.hideAlert() }
            onCancel={() => this.hideAlert() }
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });    

  }


  handleChange(state){

    this.setState({add:{...this.state.add, ...state}});
    
  }

  componentDidMount() {
  }

  render() {
    const { translate } = this.props;

    return (
      <div>
        <GridContainer>
          {this.state.alert}
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.customer_application.content")} />
          </ItemGrid> 
          {this.state.nextStep?(
          <ItemGrid xs={12} sm={12} md={12}>
            <IconCard
              icon={InfoOutline}
              title="Next step: Set up a shipment"
              iconColor="green"
              content={
                <GridContainer>
                  <ItemGrid xs={12} sm={12} md={12}>
                    Create a shipment
                  </ItemGrid>
                  <ItemGrid xs={12} sm={12} md={12}>                    
                    <Button 
                      round 
                      color="primary" 
                      onClick={() => this.props.history.push('/customer/shipments') } 
                    >
                      Get Started
                    </Button>
                  </ItemGrid>
                </GridContainer>
              }
            />
          </ItemGrid>
            ):(
          <ItemGrid xs={12} sm={12} md={12}>
            <Wizard
              key={this.state.wizardId}
              validate
              steps={[
                { stepName: "About", stepComponent: Step1, stepId: "about" },
                { stepName: "Personalization", stepComponent: Step2, stepId: "personalization" },
                { stepName: "Terms and Conditions", stepComponent: Step3, stepId: "terms" },
              ]}
              title="Customer Application"
              subtitle="This information will let us know more about you."
              finishButtonClick={this.handleSubmit}
              sendState={this.handleChange}
            />
          </ItemGrid>             
          )}
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchPostApplication: (user, data) => postCustomerApplication(user, data),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
    userRoles: state.user.roles,
  }
}

export default compose(
  withStyles(applicationStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Application);




// WEBPACK FOOTER //
// ./src/views/Customer/Application.jsx